import Breakpoint from '../helpers/breakpoint';

const SiteSearchPlaceholder               = (() => {
	const DOM                  = {};
	const transitionBreakpoint = "lg";
	const placeholderText      = 'e.g. front door furniture, letter plates, door knobs…';

	const cacheDom       = () => {
		DOM.searchFields = document.querySelectorAll( '.search-field' );
	}

	const updatePlaceholderText  = () => {
		DOM.searchFields .forEach(
			(item) => {
            item.placeholder = placeholderText;
			}
		);
	}

	const eventListener = () => {
		if (DOM.searchFields && Breakpoint.isBreakpointUp( transitionBreakpoint )) {
			document.addEventListener( "DOMContentLoaded", updatePlaceholderText );
		}
	};

	const init = () => {
		cacheDom();
		eventListener();
	};

	return {
		init,
	};
})();

export default SiteSearchPlaceholder;
